import { render, staticRenderFns } from "./supervisionAnswerListCustomer.vue?vue&type=template&id=1b931cd5&scoped=true"
import script from "./supervisionAnswerListCustomer.vue?vue&type=script&lang=js"
export * from "./supervisionAnswerListCustomer.vue?vue&type=script&lang=js"
import style0 from "./supervisionAnswerListCustomer.vue?vue&type=style&index=0&id=1b931cd5&prod&lang=scss&scoped=true"
import style1 from "./supervisionAnswerListCustomer.vue?vue&type=style&index=1&id=1b931cd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b931cd5",
  null
  
)

export default component.exports